import type { FilterOption } from "./filter-select";

export function optionMatchesSearch(option: FilterOption, search: string) {
  const query = search.trim().toLowerCase();
  if (!query) return true;
  return option.label.toLowerCase().includes(query) || option.value.toLowerCase().includes(query);
}
